// Top-line counters + top-answer breakdowns for the IQ admin dashboard.
const CARDS = [
  { key: "total", label: "Total Registrations" },
  { key: "consent_updates_count", label: "Opted In: Updates" },
  { key: "consent_research_count", label: "Opted In: Research" },
];

function TopList({ title, data }) {
  const entries = Object.entries(data || {}).slice(0, 5);
  return (
    <div className="bg-[#111] border border-zinc-800 rounded-xl p-5">
      <span className="font-mono text-[11px] tracking-[0.15em] uppercase text-zinc-500">{title}</span>
      <div className="space-y-2 mt-3">
        {entries.length === 0 && <p className="font-body text-sm text-zinc-600">No data yet</p>}
        {entries.map(([label, count]) => (
          <div key={label} className="flex items-center justify-between gap-3">
            <span className="font-body text-sm text-zinc-300 truncate">{label}</span>
            <span className="font-mono text-xs text-[#ff2d78] shrink-0">{count}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function IQAdminStats({ stats }) {
  if (!stats) return null;
  return (
    <div data-testid="iq-admin-stats" className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {CARDS.map((c) => (
          <div key={c.key} className="bg-[#111] border border-zinc-800 rounded-xl p-5">
            <span className="font-mono text-[11px] tracking-[0.15em] uppercase text-zinc-500">{c.label}</span>
            <p className="font-heading text-3xl font-light text-white mt-2">{stats[c.key] ?? 0}</p>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <TopList title="Top Products" data={stats.by_product} />
        <TopList title="Top Features" data={stats.by_feature} />
        <TopList title="Top Frustrations" data={stats.by_frustration} />
        <TopList title="Top Devices" data={stats.by_device} />
        <TopList title="Sources" data={stats.by_source} />
      </div>
    </div>
  );
}
